
import React, {FC} from 'react';
import {Check} from 'assets/exports';

import * as styles from './styles.module.scss';

const ListItem: FC<{children: string}> = ({children}) => {
	return (
		<li>
			<div><Check className={styles.check} /></div>
			<div>{children}</div>
		</li>
	);
};

export const PackageListMobile = () => (
	<div className={styles.list}>
		<ul>
			<ListItem>
				Build a package to get follow-up scans at the best prices
			</ListItem>
			<ListItem>
				Plan scans according to your timelines and goals for the year
			</ListItem>
			<ListItem>
				Bring friends & family to make your health journey
				more fun (and effective!)
			</ListItem>
		</ul>
	</div>
);

export const PackageListDesktop = () => (
	<div className={styles.list}>
		<span>Why build a package?</span>
		<ul>
			<ListItem>
				Build a package to get follow-up scans at the best prices
			</ListItem>
			<ListItem>
				Bring friends to make your health journey
				more fun (and effective!)
			</ListItem>
		</ul>
	</div>
);
